import Debug from 'debug'
import { useMemo } from 'react'

export default function useDebug(name: string) {
  return useMemo(() => Debug(name), [name])
}
